import React from 'react';
import PropTypes from 'prop-types';

const variants = {
  primary: 'bg-blue-50 text-blue-700 border-blue-100 dark:bg-blue-950/40 dark:text-blue-400 dark:border-blue-900/50',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-100 dark:bg-emerald-950/40 dark:text-emerald-400 dark:border-emerald-900/50',
  warning: 'bg-amber-50 text-amber-700 border-amber-100 dark:bg-amber-950/40 dark:text-amber-400 dark:border-amber-900/50',
  danger: 'bg-rose-50 text-rose-700 border-rose-100 dark:bg-rose-950/40 dark:text-rose-400 dark:border-rose-900/50',
  info: 'bg-cyan-50 text-cyan-700 border-cyan-100 dark:bg-cyan-950/40 dark:text-cyan-400 dark:border-cyan-900/50',
  neutral: 'bg-slate-50 text-slate-700 border-slate-100 dark:bg-slate-950/40 dark:text-slate-400 dark:border-slate-900/50'
};

const sizes = {
  sm: 'px-2 py-0.5 text-[10px] rounded-lg',
  md: 'px-2.5 py-1 text-xs rounded-xl',
  lg: 'px-3 py-1.5 text-sm rounded-2xl'
};

const Badge = ({ 
  children, 
  variant = 'neutral', 
  size = 'md', 
  className = '',
  ...props 
}) => {
  return (
    <span 
      className={`inline-flex items-center gap-1 font-bold uppercase tracking-wider border shadow-sm ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['primary', 'success', 'warning', 'danger', 'info', 'neutral']),
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  className: PropTypes.string
};

export default Badge;
